/* eslint-env browser */
/* eslint-disable no-alert */

// ================================================================
//  COMPLETE CARE HERO — Scroll-Animated First Section
//  • Bottles split left/right on scroll (Day → LEFT, Night → RIGHT)
//  • Features constellation fades in as user scrolls
//  • Smooth cubic easing for premium feel
//  • Fully mobile-aware
// ================================================================
function initCompleteHero() {
  const hero = document.querySelector('.complete-hero');
  const sticky = document.getElementById('completeHeroSticky');
  const header = document.querySelector('.ch-hero-header');
  const dayUnit = document.querySelector('.ch-product-unit--day');
  const nightUnit = document.querySelector('.ch-product-unit--night');
  const features = document.getElementById('chFeaturesLayer');
  const capsules = document.querySelector('.ch-bottom-capsules');
  const scrollCue = document.getElementById('chScrollCue');
  if (!hero || !sticky) return;

  let ticking = false;

  function easeInOut(t) {
    // Cubic ease-in-out
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function update() {
    ticking = false;
    const heroRect = hero.getBoundingClientRect();
    const scrolled = -heroRect.top;                          // px scrolled past top
    const maxScroll = hero.offsetHeight - window.innerHeight; // total scrollable distance
    const progress = maxScroll > 0 ? Math.min(Math.max(scrolled / maxScroll, 0), 1) : 0;

    // ── Bottle split: starts at 4% scroll, fully reaches Image 2 state by 48% scroll ──
    const splitRaw = Math.min(Math.max((progress - 0.04) / 0.54, 0), 1);
    const splitEase = easeInOut(splitRaw);

    // Travel distance — positions Day on left of plinth, Night on right of plinth (matches Image 2)
    const isSmallPhone = window.innerWidth <= 480;
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 900;
    const maxTravel = Math.min(
      window.innerWidth * (isSmallPhone ? 0.09 : isMobile ? 0.12 : isTablet ? 0.23 : 0.26),
      isSmallPhone ? 40 : isMobile ? 60 : 340
    );
    const travel = splitEase * maxTravel;

    if (dayUnit) {
      dayUnit.style.transform = `translate3d(${-travel}px, 0, 0)`;
      dayUnit.style.opacity = '1';
      dayUnit.style.willChange = 'transform';
    }
    if (nightUnit) {
      nightUnit.style.transform = `translate3d(${travel}px, 0, 0)`;
      nightUnit.style.opacity = '1';
      nightUnit.style.willChange = 'transform';
    }

    // ── Features constellation: fades in as bottles spread, remains 100% visible in Image 2 state ──
    if (features) {
      const featAlpha = Math.min(Math.max(splitEase * 1.3, 0), 1);
      features.style.opacity = featAlpha.toFixed(3);
      features.style.pointerEvents = featAlpha > 0.5 ? 'auto' : 'none';
    }

    // ── Scroll cue: fades out gently once scrolling begins ──
    if (scrollCue) {
      scrollCue.style.opacity = progress > 0.04 ? '0' : '0.85';
    }

    // ── Header: always stays fully visible ──
    if (header) {
      header.style.opacity = '1';
    }

    // ── Capsules: always stays fully visible once shown ──
    if (capsules) {
      capsules.style.opacity = '1';
      capsules.style.transform = 'none';
    }

    // ── Features: fade in as bottles split, then STAY at full opacity ──
    if (features) {
      const featAlpha = Math.min(Math.max(splitEase * 1.3, 0), 1);
      features.style.opacity = featAlpha.toFixed(3);
      features.style.pointerEvents = featAlpha > 0.5 ? 'auto' : 'none';
    }

    // ── Reveal class for any entrance animations ──
    if (progress >= 0.20) {
      hero.classList.add('is-revealed');
    } else {
      hero.classList.remove('is-revealed');
    }
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll);

  update(); // run once on load
}


// ---- USP Headline entrance reveal & parting jars ----
(function initUspHeadReveal() {
  const el = document.getElementById('uspHead');
  if (!el) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        el.classList.add('in-view');
        io.unobserve(el);
      }
    });
  }, { threshold: 0.3 });
  io.observe(el);
})();

function initPartingJars(sectionId, jarLeftId, jarRightId) {
  const section = document.getElementById(sectionId);
  const jarLeft = document.getElementById(jarLeftId);
  const jarRight = document.getElementById(jarRightId);
  if (!section || !jarLeft || !jarRight) return;

  let ticking = false;
  let mouseX = 0, mouseY = 0;

  function update() {
    ticking = false;
    if (!section || !jarLeft || !jarRight) return;
    const isMobile = window.innerWidth <= 768;
    const sectionHeight = section.offsetHeight || 1;
    const progress = Math.min(Math.max(-section.getBoundingClientRect().top / sectionHeight, 0), 1);

    const exit = 1 - Math.max((progress - 0.7) / 0.3, 0);
    const opacity = exit;

    const tiltX = (mouseX / window.innerWidth - 0.5) * 8;
    const tiltY = (mouseY / window.innerHeight - 0.5) * 8;

    if (isMobile) {
      const travel = Math.min(window.innerWidth * 0.32, 140);
      const offset = progress * travel;
      jarLeft.style.transform = `translate3d(${-offset + tiltX}px, ${tiltY}px, 0)`;
      jarLeft.style.opacity = opacity;
      jarRight.style.transform = `translate3d(${offset - tiltX}px, ${-tiltY}px, 0)`;
      jarRight.style.opacity = opacity;
    } else {
      const base = Math.min(window.innerWidth * 0.25, 340);
      const travel = Math.min(window.innerWidth * 0.26, 360);
      const offset = base + progress * travel;
      jarLeft.style.setProperty('--x', `${-offset + tiltX}px`);
      jarLeft.style.transform = `translate(calc(-50% + ${-offset + tiltX}px), calc(-50% + ${tiltY}px))`;
      jarLeft.style.opacity = opacity;
      jarRight.style.transform = `translate(calc(-50% + ${offset - tiltX}px), calc(-50% + ${-tiltY}px))`;
      jarRight.style.opacity = opacity;
    }
  }

  function onScroll() {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }

  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX; mouseY = e.clientY; onScroll();
  }, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

// ---- quantity steppers — synced to Shopify hidden quantity input ----
function initQtySteppers() {
  document.querySelectorAll('.qty').forEach(qty => {
    const val = qty.querySelector('.qtyVal');
    const hiddenQty = qty.closest('form') && qty.closest('form').querySelector('[name="quantity"]');
    qty.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.step, 10);
        const current = parseInt(val.textContent, 10) || 1;
        const next = Math.max(1, current + step);
        val.textContent = next;
        if (hiddenQty) hiddenQty.value = next; // keep Shopify form in sync
      });
    });
  });
}

// ---- Add to Cart — Shopify AJAX Cart API ----
function initAddToCartButtons() {
  document.querySelectorAll('.aurique-product .btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

      const variantId = btn.dataset.variantId;
      const qtyEl = btn.closest('.aurique-product-copy')
        && btn.closest('.aurique-product-copy').querySelector('.qtyVal');
      const qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;

      const defaultLabel = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(res => res.json())
        .then(() => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = 'Added to Cart ✓';
          btn.style.background = '#2e4e49';
          btn.style.borderColor = '#2e4e49';
          // Refresh Shopify cart count bubble if theme supports it
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => {
            btn.classList.remove('is-added');
            btn.textContent = defaultLabel;
            btn.style.background = '';
            btn.style.borderColor = '';
          }, 1800);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.textContent = defaultLabel;
          alert('Could not add to cart. Please try again.');
        });
    });
  });
}

// ---- Compare card Buy buttons — Shopify AJAX ----
function initCompareButtons() {
  document.querySelectorAll('.compare .btn.gold[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (btn.classList.contains('is-added')) return;
      const variantId = btn.dataset.variantId;
      const defaultLabel = btn.textContent;
      btn.classList.add('is-added');
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(() => {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => {
            btn.classList.remove('is-added');
            btn.textContent = defaultLabel;
          }, 1800);
        })
        .catch(() => {
          btn.classList.remove('is-added');
          btn.textContent = defaultLabel;
          alert('Could not add to cart. Please try again.');
        });
    });
  });
}

// ---- Mobile Ingredients Card Auto-Advancing Carousel ----
function initMobileCardAutoPlay() {
  const container = document.getElementById('nhIngredients');
  if (!container) return;

  let autoTimer = null;
  let currentCardIndex = 0;

  function nextCard() {
    if (window.innerWidth >= 860) return;
    if (!container.classList.contains('is-active')) return;
    const cards = container.querySelectorAll('.nh-ing-item');
    if (!cards.length) return;
    currentCardIndex = (currentCardIndex + 1) % cards.length;
    const targetCard = cards[currentCardIndex];
    const scrollLeft = targetCard.offsetLeft - (container.clientWidth - targetCard.clientWidth) / 2;
    container.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
  }

  function startAutoPlay() { stopAutoPlay(); autoTimer = setInterval(nextCard, 1400); }
  function stopAutoPlay() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

  container.addEventListener('touchstart', () => stopAutoPlay(), { passive: true });
  container.addEventListener('touchend', () => setTimeout(startAutoPlay, 3000), { passive: true });
  startAutoPlay();
}

function initAll() {
  initCompleteHero();
  initPartingJars('uspHero', 'uspJarLeft', 'uspJarRight');
  initQtySteppers();
  initAddToCartButtons();
  initCompareButtons();
  initMobileCardAutoPlay();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

